import React, { useState, useEffect, Suspense } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ControlPanelLayout from 'layouts/ControlPanelLayout';
import { Result, Spin } from 'antd';
import { Fade } from 'react-awesome-reveal';
import { NetworkSettingsProvider as NetworkSettingsContextProvider } from 'contexts/NetworkSettingsContext';
import NetworkSettingsProvider from 'components/NetworkSettingsProvider';
import 'assets/css/network-settings.css';

// Pages
import Dashboard from 'pages/dashboard';
import Clock from 'pages/clock';
import Login from 'pages/login';
import Logout from 'pages/user/logout';
import AccessControl from 'pages/access_control';

// USER ROUTES
import UsersList from 'pages/user';
import SuperAdminUsersList from 'pages/user/super-admins';
import UsersCreate from 'pages/user/create';
import UsersUpdate from 'pages/user/update';
import UsersUpdatePassword from 'pages/user/update-password';
import UsersPrint from 'pages/user/print';
import UsersView from 'pages/user/view';
import UsersLegalAcceptance from 'pages/user/legal-acceptance';
import AcceptTerms from 'pages/legal/accept';
import LegalDocumentPage from 'pages/legal/document';
import TermsGate from 'components/TermsGate';

// THIRD-PARTY CREDENTIALS ROUTES
import ThirdPartyCredentialsList from 'pages/third_party_credentials/index';
import ThirdPartyCredentialsCreate from 'pages/third_party_credentials/create';
import ThirdPartyCredentialsUpdate from 'pages/third_party_credentials/update';

// CALL REPORT

import CallReport from 'pages/call-report';

// CLIENT ROUTES
import ClientsList from 'pages/client';
import ClientsCreate from 'pages/client/create';
import ClientsUpdate from 'pages/client/update';

// API KEYS ROUTES
import ApiKeysList from 'pages/apikeys';
import ApiKeysCreate from 'pages/apikeys/create';
import ApiKeysUpdate from 'pages/apikeys/update';

// COMPANY ROUTES
import CompaniesList from 'pages/company';
import CompaniesCreate from 'pages/company/create';
import CompaniesUpdate from 'pages/company/update';
import CompaniesView from 'pages/company/view';
import CompaniesRole from 'pages/company/role';
import YardiSyncCompanies from 'pages/yardi_sync';

// BRANCH ROUTES
import BranchesList from 'pages/branch';
import BranchesCreate from 'pages/branch/create';
import BranchesUpdate from 'pages/branch/update';
import BranchesView from 'pages/branch/view';

// BRANCH NETWORK ROUTES
import BranchnetworkStats from 'pages/branchnetwork/stats';
import BranchnetworkStatsWifiusers from 'pages/branchnetwork/stats-wifiusers';

// SUPER ADMIN DATA EXPORT
import SuperAdminDataExport from 'pages/super_admin/data-export';

// WORKSPACE ROUTES
import WorkspaceList from 'pages/workspace';
import WorkspaceCreate from 'pages/workspace/create.';
import WorkspaceUpload from 'pages/workspace_uploads';
import WorkspaceUpdate from 'pages/workspace/update';
import WorkspaceUploadCreate from 'pages/workspace_uploads/create';
import WorkspaceUploadUpdate from 'pages/workspace_uploads/update';
import WorkspacePropertyList from 'pages/workspace_property';
import WorkspacePropertyCreate from 'pages/workspace_property/create';
import WorkspacePropertyUpdate from 'pages/workspace_property/update';
import WorkspaceQuotes from 'pages/workspace_quote';

//SALES PERSON ROUTES

import Salesperson from 'pages/sales_person';
import SalespersonCreate from 'pages/sales_person/create';
import SalespersonUpdate from 'pages/sales_person/update';

// CATEGORY ROUTES
import CategoriesList from 'pages/category';
import CategoriesCreate from 'pages/category/create';
import CategoriesUpdate from 'pages/category/update';
import CategorieShare from 'pages/category/share';

//KNOWLEDGE BASE ROUTES
import KnowledgeBaseViewPostDetail from 'pages/knowledge_base/knowledge_base_view_post_detail';
import KnowledgeBaseViewPostList from 'pages/knowledge_base/knowledge_base_view_post_list';
import KnowledgeBaseView from 'pages/knowledge_base/view';
import KnowledgeBaseManage from 'pages/knowledge_base/manage';
import KnowledgeBaseList from 'pages/knowledge_base';
import KnowledgeBaseCreate from 'pages/knowledge_base/create';
import KnowledgeBaseUpdate from 'pages/knowledge_base/update';
import KnowledgeBaseWebsite from 'pages/website/menu';

// KNOWLEDGE BOT ROUTES
// Temporarily disabled - chat assist feature not working, can't access encrypted data
// import KnowledgeBot from 'pages/knowledgebot';

// SEARCH ROUTES
import SearchResults from 'pages/search';

// GALLERY ROUTES
import GalleryList from 'pages/gallery';
import GalleryCreate from 'pages/gallery/create';
import GalleryUpdate from 'pages/gallery/update';
import GalleryView from 'pages/gallery/view';

// ISP PROVIDER ROUTES
import IspProviderList from 'pages/isp_provider';
import IspProviderCreate from 'pages/isp_provider/create';
import IspProviderUpdate from 'pages/isp_provider/update';

// ISP ROUTES
import IspList from 'pages/isp';
import IspCreate from 'pages/isp/create';
import IspUpdate from 'pages/isp/update';
import IspView from 'pages/isp/view';

// Utility ROUTES
import UtilityProvidersList from 'pages/utility_providers';
import UtilityProvidersCreate from 'pages/utility_providers/create';
import UtilityProvidersUpdate from 'pages/utility_providers/update';
import UtilityProvidersView from 'pages/utility_providers/view';

// Service ROUTES
import ServiceProvidersList from 'pages/service_providers';
import ServiceProvidersCreate from 'pages/service_providers/create';
import ServiceProvidersUpdate from 'pages/service_providers/update';
import ServiceProvidersView from 'pages/service_providers/view';

// ADMINCONTROL ROUTES
import AdminControl from 'pages/admincontrol';
import ExpectScripts from 'pages/expect-scripts';
import RaddbReports from 'pages/raddb-reports';
import EmailSendLogList from 'pages/email_send_log';

// RACK ROUTES
import RackRegistryList from 'pages/rackregistry';
import RackRegistryCreate from 'pages/rackregistry/create';
import RackRegistryUpdate from 'pages/rackregistry/update';
import RackRegistryView from 'pages/rackregistry/view';
import RackRegistryUpload from 'pages/rackregistry/upload';

import RackDeviceList from 'pages/rackdevice';
import RackDeviceCreate from 'pages/rackdevice/create';
import RackDeviceUpdate from 'pages/rackdevice/update';
import RackDeviceView from 'pages/rackdevice/view';
import RackDeviceUpload from 'pages/rackdevice/upload';

// TIME TRACKER ROUTES
import TimeTrackerProjectsList from 'pages/time_tracker/projects';
import TimeTrackerProjectCreate from 'pages/time_tracker/projects/create';
import TimeTrackerProjectUpdate from 'pages/time_tracker/projects/update';
import TimeTrackerProjectView from 'pages/time_tracker/projects/view';
import TimeTrackerPage from 'pages/time_tracker/tracker';
import TimeTrackerProjectEntriesPage from 'pages/time_tracker/tracker/project_entries';
import TimeTrackerReportsPage from 'pages/time_tracker/reports';
import TimeTrackerOpenTimersPage from 'pages/time_tracker/open_timers';
import TimeTrackerUserGroupsList from 'pages/time_tracker/user_groups';
import TimeTrackerUserGroupCreate from 'pages/time_tracker/user_groups/create';
import TimeTrackerUserGroupUpdate from 'pages/time_tracker/user_groups/update';

// SCHEDULING ROUTES
import SchedulesList from 'pages/time_tracker/scheduling';
import ScheduleCreate from 'pages/time_tracker/scheduling/create';
import ScheduleUpdate from 'pages/time_tracker/scheduling/update';
import SchedulingBoard from 'pages/time_tracker/scheduling/board';
import SchedulingActivitiesList from 'pages/time_tracker/scheduling/activities';

// BILLING SYSTEM ROUTES
import BillingDashboard from 'pages/billing_system/dashboard';
import BillingItemList from 'pages/billing_system/items';
import BillingItemCreate from 'pages/billing_system/items/create';
import BillingItemUpdate from 'pages/billing_system/items/update';
import BillingCategoryList from 'pages/billing_system/categories';
import BillingCategoryCreate from 'pages/billing_system/categories/create';
import BillingCategoryUpdate from 'pages/billing_system/categories/update';
import BillingTaxRateList from 'pages/billing_system/tax_rates';
import BillingTaxRateCreate from 'pages/billing_system/tax_rates/create';
import BillingTaxRateUpdate from 'pages/billing_system/tax_rates/update';
import BillingInvoiceList from 'pages/billing_system/invoices';
import BillingInvoiceCreate from 'pages/billing_system/invoices/create';
import BillingInvoiceUpdate from 'pages/billing_system/invoices/update';
import BillingInvoiceView from 'pages/billing_system/invoices/view';
import BillingRecurringList from 'pages/billing_system/recurring';
import BillingRecurringCreate from 'pages/billing_system/recurring/create';
import BillingRecurringUpdate from 'pages/billing_system/recurring/update';
import BillingPaymentList from 'pages/billing_system/payments';
import BillingSettingsPage from 'pages/billing_system/settings';

// TICKET SYSTEM
import TicketDashboard from 'pages/ticket_system/dashboard';
import TicketProjectsList from 'pages/ticket_system/projects';
import TicketProjectCreate from 'pages/ticket_system/projects/create';
import TicketProjectUpdate from 'pages/ticket_system/projects/update';
import TicketProjectBoard from 'pages/ticket_system/projects/board';
import TicketAllList from 'pages/ticket_system/tickets';
import TicketView from 'pages/ticket_system/tickets/view';

import { PrivateRoute } from 'utils';

// FETCH ROUTE INFO FROM FILES AND GENERATE ROUTE ARRAY
const dynamicImports = [];
dynamicImports.push(import('./pages/network-management/routes'));
dynamicImports.push(import('./pages/gallery/routes'));
dynamicImports.push(import('./pages/workspace/routes'));
dynamicImports.push(import('./pages/sales_person/routes'));
dynamicImports.push(import('./pages/billing/routes'));
dynamicImports.push(import('./pages/website/routes'));

let promises = [];
for (let i = 0; i < dynamicImports.length; i++) {
  promises.push(dynamicImports[i]);
}

function App() {
  const [dynamicRoutes, setDynamicRoutes] = useState([]);
  const [pageComponents, setPageComponents] = useState([]);

  useEffect(() => {
    Promise.all(promises).then((resolvedItems) => {
      let items = [];
      let _pageComponents = [];
      for (let i = 0; i < resolvedItems.length; i++) {
        const mainMenu = resolvedItems[i].default;
        items.push(mainMenu);

        // Handle main menu component
        if (mainMenu.component) {
          const path = `./pages${mainMenu.component}`;
          _pageComponents[mainMenu.key] = React.lazy(() => import(`${path}`));
        }

        // Register a flat item (and any nested subItems) onto _pageComponents
        const registerItem = (item) => {
          if (item.component) {
            const path = `./pages${item.component}`;
            _pageComponents[item.key] = React.lazy(() => import(`${path}`));
          }
          if (item.subItems) {
            item.subItems.forEach((subItem) => {
              if (subItem.component) {
                const path = `./pages${subItem.component}`;
                _pageComponents[subItem.key] = React.lazy(() =>
                  import(`${path}`),
                );
              }
            });
          }
        };

        // Handle sections and their items
        if (mainMenu.sections) {
          mainMenu.sections.forEach((section) => {
            if (section.items) {
              section.items.forEach(registerItem);
            }
          });
        }

        // Handle top-level items (used by billing/website routes)
        if (mainMenu.items) {
          mainMenu.items.forEach(registerItem);
        }
      }
      setPageComponents(_pageComponents);
      setTimeout(() => {
        setDynamicRoutes(items);
      }, 500);
    });
  }, []);

  const PublicPages = () => {
    return (
      <Switch>
        <Route exact path="/login" component={Login} />
      </Switch>
    );
  };

  const PrivatePages = () => {
    return (
      <TermsGate>
      <ControlPanelLayout>
        <Suspense
          fallback={
            <div>
              <Spin />
            </div>
          }
        >
          <Fade>
            <Switch>
              <PrivateRoute exact path="/call-report" component={CallReport} />
              <PrivateRoute
                exact
                path="/clients/create"
                component={ClientsCreate}
              />
              <PrivateRoute
                exact
                path="/clients/update/:id"
                component={ClientsUpdate}
              />
              <PrivateRoute exact path="/clients" component={ClientsList} />

              <PrivateRoute exact path="/apikeys" component={ApiKeysList} />
              <PrivateRoute
                exact
                path="/apikeys/create"
                component={ApiKeysCreate}
              />
              <PrivateRoute
                exact
                path="/apikeys/update/:id"
                component={ApiKeysUpdate}
              />

              <PrivateRoute
                exact
                path="/companies/create"
                component={CompaniesCreate}
              />
              <PrivateRoute
                exact
                path="/companies/update/:id"
                component={CompaniesUpdate}
              />
              <PrivateRoute exact path="/companies" component={CompaniesList} />
              <PrivateRoute
                exact
                path="/companies/view/:id"
                component={CompaniesView}
              />

              <PrivateRoute
                exact
                path="/companies/role/:id"
                component={CompaniesRole}
              />

              <PrivateRoute
                exact
                path="/yardi-sync"
                component={YardiSyncCompanies}
              />

              <PrivateRoute
                exact
                path="/branches/create"
                component={BranchesCreate}
              />
              <PrivateRoute
                exact
                path="/branches/update/:id"
                component={BranchesUpdate}
              />
              <PrivateRoute exact path="/branches" component={BranchesList} />

              <PrivateRoute
                exact
                path="/branch/view/:id"
                component={BranchesView}
              />

              <PrivateRoute
                exact
                path="/branchnetwork/stats"
                component={BranchnetworkStats}
              />

              <PrivateRoute
                exact
                path="/branchnetwork/stats/wifiusers/:branchCustomerId"
                component={BranchnetworkStatsWifiusers}
              />

              <PrivateRoute
                exact
                path="/super-admin/data-export"
                component={SuperAdminDataExport}
              />

              <PrivateRoute exact path="/workspace" component={WorkspaceList} />

              <PrivateRoute
                exact
                path="/workspace/create"
                component={WorkspaceCreate}
              />

              <PrivateRoute
                exact
                path="/workspace/update/:id"
                component={WorkspaceUpdate}
              />

              <PrivateRoute
                exact
                path="/workspace/:workspaceLocationId/:workspaceSlug/property"
                component={WorkspacePropertyList}
              />

              <PrivateRoute
                exact
                path="/workspace/:workspaceLocationId/:workspaceSlug/property/create"
                component={WorkspacePropertyCreate}
              />

              <PrivateRoute
                exact
                path="/workspace/:workspaceLocationId/:workspaceSlug/property/update/:id"
                component={WorkspacePropertyUpdate}
              />

              <PrivateRoute
                exact
                path="/workspace/:objectId/:objectType/upload"
                component={WorkspaceUpload}
              />

              <PrivateRoute
                exact
                path="/workspace/:objectId/:objectType/upload/create"
                component={WorkspaceUploadCreate}
              />

              <PrivateRoute
                exact
                path="/workspace/:objectId/:objectType/upload/update/:id"
                component={WorkspaceUploadUpdate}
              />

              <PrivateRoute
                exact
                path="/workspace/:workspaceLocationId/property/quotes/:id"
                component={WorkspaceQuotes}
              />

              <PrivateRoute exact path="/sales" component={Salesperson} />

              <PrivateRoute
                exact
                path="/sales/create"
                component={SalespersonCreate}
              />

              <PrivateRoute
                exact
                path="/sales/update/:id"
                component={SalespersonUpdate}
              />

              <PrivateRoute
                exact
                path="/users/create"
                component={UsersCreate}
              />
              <PrivateRoute
                exact
                path="/users/update/:id"
                component={UsersUpdate}
              />
              <PrivateRoute
                exact
                path="/users/update-password/:id"
                component={UsersUpdatePassword}
              />
              <PrivateRoute
                exact
                path="/users/super-admins"
                component={SuperAdminUsersList}
              />
              <PrivateRoute exact path="/users" component={UsersList} />
              <PrivateRoute
                exact
                path="/users/legal-acceptance"
                component={UsersLegalAcceptance}
              />

              <PrivateRoute exact path="/users/print" component={UsersPrint} />
              <PrivateRoute
                exact
                path="/users/view/:id"
                component={UsersView}
              />

              <PrivateRoute
                exact
                path="/third-party-credentials/create"
                component={ThirdPartyCredentialsCreate}
              />
              <PrivateRoute
                exact
                path="/third-party-credentials/update/:id"
                component={ThirdPartyCredentialsUpdate}
              />
              <PrivateRoute
                exact
                path="/third-party-credentials"
                component={ThirdPartyCredentialsList}
              />

              <PrivateRoute exact path="/billing/categories" component={BillingCategoryList} />
              <PrivateRoute exact path="/billing/categories/create" component={BillingCategoryCreate} />
              <PrivateRoute exact path="/billing/categories/update/:id" component={BillingCategoryUpdate} />

              <PrivateRoute
                exact
                path="/:type/categories/create"
                component={CategoriesCreate}
              />
              <PrivateRoute
                exact
                path="/:type/categories/update/:id"
                component={CategoriesUpdate}
              />
              <PrivateRoute
                exact
                path="/:type/categories/share/:id"
                component={CategorieShare}
              />
              <PrivateRoute
                exact
                path="/:type/categories"
                component={CategoriesList}
              />
              {/* Temporarily disabled - chat assist feature not working, can't access encrypted data */}
              {/* <PrivateRoute exact path="/:type/chat" component={KnowledgeBot} /> */}

              <PrivateRoute
                exact
                path="/knowledge-base/manage/category-:id"
                component={KnowledgeBaseManage}
              />

              <PrivateRoute
                exact
                path="/knowledge-base/view/post-:id"
                component={KnowledgeBaseViewPostDetail}
              />
              <PrivateRoute
                exact
                path="/knowledge-base/view/category-:id"
                component={KnowledgeBaseViewPostList}
              />
              <PrivateRoute
                exact
                path="/knowledge-base/view"
                component={KnowledgeBaseView}
              />
              <PrivateRoute
                exact
                path="/knowledge-base/create"
                component={KnowledgeBaseCreate}
              />
              <PrivateRoute
                exact
                path="/knowledge-base/update/:id"
                component={KnowledgeBaseUpdate}
              />
              <PrivateRoute
                exact
                path="/knowledge-base/website"
                component={KnowledgeBaseWebsite}
              />

              <PrivateRoute
                exact
                path="/knowledge-base"
                component={KnowledgeBaseList}
              />

              <PrivateRoute exact path="/search" component={SearchResults} />

              <PrivateRoute
                exact
                path="/gallery/create"
                component={GalleryCreate}
              />
              <PrivateRoute
                exact
                path="/gallery/update/:id"
                component={GalleryUpdate}
              />
              <PrivateRoute
                exact
                path="/gallery/view/:id"
                component={GalleryView}
              />
              <PrivateRoute exact path="/gallery" component={GalleryList} />

              <PrivateRoute
                exact
                path="/manage-isp-provider/create"
                component={IspProviderCreate}
              />
              <PrivateRoute
                exact
                path="/manage-isp-provider/update/:id"
                component={IspProviderUpdate}
              />
              <PrivateRoute
                exact
                path="/manage-isp-provider"
                component={IspProviderList}
              />

              <PrivateRoute exact path="/isp" component={IspList} />
              <PrivateRoute exact path="/isp/create" component={IspCreate} />
              <PrivateRoute exact path="/isp/view/:id" component={IspView} />
              <PrivateRoute
                exact
                path="/isp/update/:id"
                component={IspUpdate}
              />
              <PrivateRoute
                exact
                path="/utility-providers"
                component={UtilityProvidersList}
              />

              <PrivateRoute
                exact
                path="/utility-providers/create"
                component={UtilityProvidersCreate}
              />
              <PrivateRoute
                exact
                path="/utility-providers/view/:id"
                component={UtilityProvidersView}
              />
              <PrivateRoute
                exact
                path="/utility-providers/update/:id"
                component={UtilityProvidersUpdate}
              />

              <PrivateRoute
                exact
                path="/service-providers"
                component={ServiceProvidersList}
              />

              <PrivateRoute
                exact
                path="/service-providers/create"
                component={ServiceProvidersCreate}
              />
              <PrivateRoute
                exact
                path="/service-providers/view/:id"
                component={ServiceProvidersView}
              />
              <PrivateRoute
                exact
                path="/service-providers/update/:id"
                component={ServiceProvidersUpdate}
              />

              <PrivateRoute path="/clock" component={Clock} />

              <PrivateRoute path="/access-control" component={AccessControl} />

              <PrivateRoute path="/admincontrol" component={AdminControl} />

              <PrivateRoute path="/expect-scripts" component={ExpectScripts} />
              <PrivateRoute path="/raddb-reports" component={RaddbReports} />
              <PrivateRoute
                path="/email-send-log"
                component={EmailSendLogList}
              />

              {/* RACK REGISTRY ROUTES */}
              <PrivateRoute
                exact
                path="/rackregistry"
                component={RackRegistryList}
              />
              <PrivateRoute
                exact
                path="/rackregistry/create"
                component={RackRegistryCreate}
              />
              <PrivateRoute
                exact
                path="/rackregistry/update/:id"
                component={RackRegistryUpdate}
              />
              <PrivateRoute
                exact
                path="/rackregistry/view/:id"
                component={RackRegistryView}
              />
              <PrivateRoute
                exact
                path="/rackregistry/upload/:id"
                component={RackRegistryUpload}
              />

              {/* RACK DEVICE ROUTES */}
              <PrivateRoute
                exact
                path="/rackdevice"
                component={RackDeviceList}
              />
              <PrivateRoute
                exact
                path="/rackdevice/create"
                component={RackDeviceCreate}
              />
              <PrivateRoute
                exact
                path="/rackdevice/update/:id"
                component={RackDeviceUpdate}
              />
              <PrivateRoute
                exact
                path="/rackdevice/view/:id"
                component={RackDeviceView}
              />
              <PrivateRoute
                exact
                path="/rackdevice/upload/:id"
                component={RackDeviceUpload}
              />

              {/* TIME TRACKER ROUTES */}
              <PrivateRoute
                exact
                path="/time-tracker/projects"
                component={TimeTrackerProjectsList}
              />
              <PrivateRoute
                exact
                path="/time-tracker/projects/create"
                component={TimeTrackerProjectCreate}
              />
              <PrivateRoute
                exact
                path="/time-tracker/projects/view/:id"
                component={TimeTrackerProjectView}
              />
              <PrivateRoute
                exact
                path="/time-tracker/projects/update/:id"
                component={TimeTrackerProjectUpdate}
              />
              <PrivateRoute
                exact
                path="/time-tracker/user-groups"
                component={TimeTrackerUserGroupsList}
              />
              <PrivateRoute
                exact
                path="/time-tracker/user-groups/create"
                component={TimeTrackerUserGroupCreate}
              />
              <PrivateRoute
                exact
                path="/time-tracker/user-groups/update/:id"
                component={TimeTrackerUserGroupUpdate}
              />
              <PrivateRoute
                exact
                path="/time-tracker/tracker"
                component={TimeTrackerPage}
              />
              <PrivateRoute
                exact
                path="/time-tracker/tracker/project/:projectId"
                component={TimeTrackerProjectEntriesPage}
              />
              <PrivateRoute
                exact
                path="/time-tracker/reports"
                component={TimeTrackerReportsPage}
              />
              <PrivateRoute
                exact
                path="/time-tracker/open-timers"
                component={TimeTrackerOpenTimersPage}
              />

              {/* TIME TRACKER – SCHEDULING */}
              <PrivateRoute
                exact
                path="/time-tracker/scheduling"
                component={SchedulesList}
              />
              <PrivateRoute
                exact
                path="/time-tracker/scheduling/create"
                component={ScheduleCreate}
              />
              <PrivateRoute
                exact
                path="/time-tracker/scheduling/update/:id"
                component={ScheduleUpdate}
              />
              <PrivateRoute
                exact
                path="/time-tracker/scheduling/activities"
                component={SchedulingActivitiesList}
              />
              <PrivateRoute
                exact
                path="/time-tracker/scheduling/:id/board"
                component={SchedulingBoard}
              />

              {/* BILLING SYSTEM */}
              <PrivateRoute exact path="/billing/dashboard" component={BillingDashboard} />
              <PrivateRoute exact path="/billing/items" component={BillingItemList} />
              <PrivateRoute exact path="/billing/items/create" component={BillingItemCreate} />
              <PrivateRoute exact path="/billing/items/update/:id" component={BillingItemUpdate} />
              <PrivateRoute exact path="/billing/tax-rates" component={BillingTaxRateList} />
              <PrivateRoute exact path="/billing/tax-rates/create" component={BillingTaxRateCreate} />
              <PrivateRoute exact path="/billing/tax-rates/update/:id" component={BillingTaxRateUpdate} />
              <PrivateRoute exact path="/billing/invoices" component={BillingInvoiceList} />
              <PrivateRoute exact path="/billing/invoices/create" component={BillingInvoiceCreate} />
              <PrivateRoute exact path="/billing/invoices/update/:id" component={BillingInvoiceUpdate} />
              <PrivateRoute exact path="/billing/invoices/view/:id" component={BillingInvoiceView} />
              <PrivateRoute exact path="/billing/recurring" component={BillingRecurringList} />
              <PrivateRoute exact path="/billing/recurring/create" component={BillingRecurringCreate} />
              <PrivateRoute exact path="/billing/recurring/update/:id" component={BillingRecurringUpdate} />
              <PrivateRoute exact path="/billing/payments" component={BillingPaymentList} />
              <PrivateRoute exact path="/billing/settings" component={BillingSettingsPage} />

              {/* TICKET SYSTEM */}
              <PrivateRoute exact path="/tickets/dashboard" component={TicketDashboard} />
              <PrivateRoute exact path="/tickets/projects" component={TicketProjectsList} />
              <PrivateRoute exact path="/tickets/projects/create" component={TicketProjectCreate} />
              <PrivateRoute exact path="/tickets/projects/update/:id" component={TicketProjectUpdate} />
              <PrivateRoute exact path="/tickets/projects/board/:id" component={TicketProjectBoard} />
              <PrivateRoute exact path="/tickets/view/:id" component={TicketView} />
              <PrivateRoute exact path="/tickets/all" component={TicketAllList} />

              <PrivateRoute path="/logout" component={Logout} />
              <PrivateRoute exact path="/" component={Dashboard} />

              {dynamicRoutes.map((dynamicRoute) => {
                const renderItem = (item) => [
                  item.component ? (
                    <PrivateRoute
                      exact
                      key={item.key}
                      path={item.url}
                      component={pageComponents[item.key]}
                    />
                  ) : null,
                  item.subItems?.map((subItem) =>
                    subItem.component ? (
                      <PrivateRoute
                        exact
                        key={subItem.key}
                        path={subItem.url}
                        component={pageComponents[subItem.key]}
                      />
                    ) : null,
                  ),
                ];

                return [
                  // Main Menu Route
                  dynamicRoute.url && dynamicRoute.component ? (
                    <PrivateRoute
                      exact
                      key={dynamicRoute.key}
                      path={dynamicRoute.url}
                      component={pageComponents[dynamicRoute.key]}
                    />
                  ) : null,

                  // Section Items Routes
                  dynamicRoute.sections?.map((section) =>
                    section.items?.map(renderItem),
                  ),

                  // Top-level Items Routes (used by billing/website routes)
                  dynamicRoute.items?.map(renderItem),
                ];
              })}
            </Switch>
          </Fade>
        </Suspense>
      </ControlPanelLayout>
      </TermsGate>
    );
  };

  return (
    <NetworkSettingsContextProvider>
      <NetworkSettingsProvider>
        <Router>
          <Switch>
            <Route path="/login" component={PublicPages} />
            <Route exact path="/legal/terms" component={LegalDocumentPage} />
            <Route exact path="/legal/privacy" component={LegalDocumentPage} />
            <Route exact path="/accept-terms" component={AcceptTerms} />
            <Route path="/" component={PrivatePages} />
          </Switch>
        </Router>
      </NetworkSettingsProvider>
    </NetworkSettingsContextProvider>
  );
}

const NotFound = () => {
  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
    />
  );
};

export default App;
